import { OpenInNew } from '@mui/icons-material';
import { TextField } from '@mui/material';
import HoverText from 'modules/documents/components/action-buttons/hoverText';
import * as React from 'react';
import { checkValidUrl } from 'utils/urlUtils';

interface IShareLinkProps {
    onChangePublicLink: (toSet: string) => void
    customPublicUrl: string
}

const PublicShareLinkEdit: React.FC<IShareLinkProps> = (props) => {
    const [isValidUrl, setIsValidUrl] = React.useState(true);
    const [urlText, setUrlText] = React.useState(props.customPublicUrl);

    //Don't actually update the post text until the focus changes.
    const onTextUpdate = (toSet: string) => {
        setIsValidUrl(checkValidUrl(toSet) || toSet === "")

        props.onChangePublicLink(toSet);
    }

    const endIcon = <OpenInNew style={{cursor: "pointer"}} onClick={() => window.open(urlText)} color="primary"/>

    return (
        <div style={{display: "flex", flexDirection: "column", marginBottom: "30px"}}>
            <HoverText inline label="Replace public share link">
                Customize the URL link that this post loads and displays when employees share this publicly.
            </HoverText>

            <TextField 
                size="small" 
                placeholder="Enter URL" 
                onBlur={(e) => onTextUpdate(e.target.value)}
                onChange={(e) => setUrlText(e.target.value)}
                helperText={isValidUrl ? "" : "Enter valid URL. Ex. https://sparrowconnected.com"}
                error={!isValidUrl}
                value={urlText}
                InputProps={{endAdornment: 
                    urlText !== "" && endIcon
                }}
            />
        </div>
    );
}

export default PublicShareLinkEdit;